import React, { useMemo, useState } from 'react';
import NavBar from '../Navbar';
import Foot from '../footer';
import { db, storage } from '../firebase';
import { v4 as uuidv4 } from 'uuid';

const secondKurtaImages = {
  "BASE": require("../assets/renders/KURTA/2ND/BASE1.png"),
  "SC": require("../assets/renders/KURTA/2ND/SC.png"),
  "SN": require("../assets/renders/KURTA/2ND/SN.png"),
  "BC2": require("../assets/renders/KURTA/2ND/BC2.png"),
  "BC4": require("../assets/renders/KURTA/2ND/BC4.png"),
  "BKC": require("../assets/renders/KURTA/2ND/BKC.png"),
  "BKN": require("../assets/renders/KURTA/2ND/BKN.png"),
  "BE": require("../assets/renders/KURTA/2ND/BE.png"),
  "SE": require("../assets/renders/KURTA/2ND/SE.png"),
  "BPL": require("../assets/renders/KURTA/2ND/BPL.png"),
  "BPR": require("../assets/renders/KURTA/2ND/BPR.png"),
  
  // Collars
  "CB": require("../assets/renders/KURTA/2ND/CB.png"),
  "CE": require("../assets/renders/KURTA/2ND/CE.png"),
  "CR": require("../assets/renders/KURTA/2ND/CR.png"),
  "CS": require("../assets/renders/KURTA/2ND/CS.png"),
  "CT": require("../assets/renders/KURTA/2ND/CT.png"),
  
  // Plackets
  "NS3": require("../assets/renders/KURTA/2ND/NS3.png"),
  "NS31": require("../assets/renders/KURTA/2ND/NS31.png"),
  "NS41": require("../assets/renders/KURTA/2ND/NS41.png"),
  "QS3": require("../assets/renders/KURTA/2ND/QS3.png"),
  "QS31": require("../assets/renders/KURTA/2ND/QS31.png"),
  "QS41": require("../assets/renders/KURTA/2ND/QS41.png"),

  // Pockets
  "LN": require("../assets/renders/KURTA/2ND/LN.png"),
  "LR": require("../assets/renders/KURTA/2ND/LR.png"),
  "LS": require("../assets/renders/KURTA/2ND/LS.png"),
  "RN": require("../assets/renders/KURTA/2ND/RN.png"),
  "RR": require("../assets/renders/KURTA/2ND/RR.png"),
  "RS": require("../assets/renders/KURTA/2ND/RS.png"),
  
  // Flaps
  "FLN": require("../assets/renders/KURTA/2ND/FLN.png"),
  "FLR": require("../assets/renders/KURTA/2ND/FLR.png"),
  "FLS": require("../assets/renders/KURTA/2ND/FLS.png"),
  "FRN": require("../assets/renders/KURTA/2ND/FRN.png"),
  "FRR": require("../assets/renders/KURTA/2ND/FRR.png"),
  "FRS": require("../assets/renders/KURTA/2ND/FRS.png"),

  // Cuff Variants
  "US1": require("../assets/renders/KURTA/2ND/US1.png"),
  "US2": require("../assets/renders/KURTA/2ND/US2.png"),
  "UR1": require("../assets/renders/KURTA/2ND/UR1.png"),
  "UR2": require("../assets/renders/KURTA/2ND/UR2.png"),
  "UN1": require("../assets/renders/KURTA/2ND/UN1.png"),
  "UN2": require("../assets/renders/KURTA/2ND/UN2.png"),
};

function Uploader({ label, onChange, accept = '.webp,.png,.jpg,.jpeg' }) {
  return (
    <div style={{ marginBottom: '12px' }}>
      <div style={{ fontWeight: 600, marginBottom: 6 }}>{label}</div>
      <input type="file" accept={accept} onChange={onChange} />
    </div>
  );
}

function KeyFileRow({ value, onChangeKey, onChangeFile }) {
  return (
    <div style={{ display: 'flex', gap: 12, marginBottom: 10 }}>
      <input
        type="text"
        placeholder="Layer Key (e.g. R, S, NS4, BPR)"
        value={value.key}
        onChange={(e) => onChangeKey(e.target.value)}
        style={{ flex: 1, padding: 8 }}
      />
      <input type="file" accept=".webp,.png,.jpg,.jpeg" onChange={onChangeFile} />
    </div>
  );
}

async function uploadToStorage(path, file) {
  const ref = storage.ref(path);
  const snap = await ref.put(file);
  const url = await snap.ref.getDownloadURL();
  return url;
}

export default function RenderUpload() {
  const [styleId, setStyleId] = useState('');
  const [collection, setCollection] = useState('kurta');
  const [firstLayers, setFirstLayers] = useState([{ key: '', file: null }]);
  const [modelSrc, setModelSrc] = useState(null);
  const [handsCuff, setHandsCuff] = useState(null);
  const [handsNonCuff, setHandsNonCuff] = useState(null);
  const [snDefault, setSnDefault] = useState(null);
  const [scVariants, setScVariants] = useState([null, null, null, null, null, null]);
  const [previewSleeve, setPreviewSleeve] = useState('SN'); // SN or SC
  const [previewVariant, setPreviewVariant] = useState('SC_1');
  // Extra Preview States
  const [previewCollar, setPreviewCollar] = useState('CR');
  const [previewPlacket, setPreviewPlacket] = useState('NS');
  const [previewPocket, setPreviewPocket] = useState('01'); // 00, 01, 11
  const [previewPocketType, setPreviewPocketType] = useState('R'); // R, N, S
  const [previewFlap, setPreviewFlap] = useState('0'); // 0, 1
  const [previewFlapType, setPreviewFlapType] = useState('R'); // R, N, S
  const [previewEpaulette, setPreviewEpaulette] = useState('0'); // 0, SE
  
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [uploadMode, setUploadMode] = useState('first'); // 'first', 'second', 'both'

  const addRow = () => setFirstLayers((a) => [...a, { key: '', file: null }]);
  const setRowKey = (i, key) => {
    const arr = [...firstLayers];
    arr[i].key = key.trim();
    setFirstLayers(arr);
  };
  const setRowFile = (i, file) => {
    const arr = [...firstLayers];
    arr[i].file = file;
    setFirstLayers(arr);
  };

  const handleSave = async () => {
    setMsg('');
    if (!styleId) {
      setMsg('Enter Style ID');
      return;
    }
    setBusy(true);
    try {
      const basePath = `renders/test_uploads/${collection}/${styleId}`;
      const payload = {};
      const displayImages = {};
      const secondImages = {};

      if (uploadMode === 'first' || uploadMode === 'both') {
        if (modelSrc) {
          const url = await uploadToStorage(`${basePath}/1st/MODEL_${uuidv4()}`, modelSrc);
          payload.modelSrc = url;
        }
        if (handsCuff) {
          const url = await uploadToStorage(`${basePath}/1st/HAND_CUFF_${uuidv4()}`, handsCuff);
          payload.handsCuffSrc = url;
        }
        if (handsNonCuff) {
          const url = await uploadToStorage(`${basePath}/1st/HAND_NONCUFF_${uuidv4()}`, handsNonCuff);
          payload.handsNonCuffSrc = url;
        }

        for (let i = 0; i < firstLayers.length; i += 1) {
          const row = firstLayers[i];
          if (row.key && row.file) {
            const url = await uploadToStorage(`${basePath}/1st/${row.key}_${uuidv4()}`, row.file);
            displayImages[row.key] = url;
          }
        }
      }

      if (uploadMode === 'second' || uploadMode === 'both') {
        if (snDefault) {
          const url = await uploadToStorage(`${basePath}/2nd/SN_DEFAULT_${uuidv4()}`, snDefault);
          secondImages.SN_DEFAULT = url;
        }
        for (let i = 0; i < scVariants.length; i += 1) {
          const file = scVariants[i];
          if (file) {
            const url = await uploadToStorage(`${basePath}/2nd/SC_${i + 1}_${uuidv4()}`, file);
            secondImages[`SC_${i + 1}`] = url;
          }
        }
      }

      const docRef = db.collection('Fabric').doc(collection).collection('Kurta').doc(styleId);
      const updateData = { ...payload };
      if (Object.keys(displayImages).length > 0) updateData.display_images = displayImages;
      if (Object.keys(secondImages).length > 0) updateData.second_images = secondImages;

      await docRef.set(
        updateData,
        { merge: true }
      );
      setMsg('Saved');
    } catch (e) {
      setMsg('Error');
      console.error(e);
    } finally {
      setBusy(false);
    }
  };

  // Local preview sources
  const modelURL = useMemo(() => (modelSrc ? URL.createObjectURL(modelSrc) : null), [modelSrc]);
  const handCuffURL = useMemo(() => (handsCuff ? URL.createObjectURL(handsCuff) : null), [handsCuff]);
  const handNonCuffURL = useMemo(() => (handsNonCuff ? URL.createObjectURL(handsNonCuff) : null), [handsNonCuff]);
  const firstLayerURLs = useMemo(() => {
    return firstLayers
      .filter(r => r.key && r.file)
      .map(r => ({ key: r.key, url: URL.createObjectURL(r.file) }));
  }, [firstLayers]);
  const secondMap = useMemo(() => {
    const map = {};
    if (snDefault) map['SN_DEFAULT'] = URL.createObjectURL(snDefault);
    scVariants.forEach((f, i) => { if (f) map[`SC_${i + 1}`] = URL.createObjectURL(f) });
    return map;
  }, [snDefault, scVariants]);
  const previewSecondLayers = useMemo(() => {
    const layers = [];
    const add = (z, src, key) => {
        if (src) layers.push({ z, src, key });
    };

    // 1. BASE
    add(3, secondKurtaImages["BASE"], "BASE");

    // 2. Sleeve / Cuff Logic
    if (previewSleeve === 'SC') {
        // SC Base
        add(4, secondKurtaImages["SC"], "SC");
        
        // Variant
        let src = secondMap[previewVariant]; // Try uploaded first
        
        // If not uploaded, use static fallback
        if (!src) {
             const map = { "SC_1": "US1", "SC_2": "UR1", "SC_3": "UN1", "SC_4": "US2", "SC_5": "UR2", "SC_6": "UN2" };
             const staticKey = map[previewVariant];
             if (staticKey) src = secondKurtaImages[staticKey];
        }
        
        if (src) add(5, src, previewVariant);
        
        // Cuff Buttons
        // SC_1, SC_2, SC_3 -> Suffix 1 -> BC2
        const isSuffix1 = ["SC_1", "SC_2", "SC_3"].includes(previewVariant);
        if (isSuffix1) add(13, secondKurtaImages["BC2"], "BC2");
        else add(13, secondKurtaImages["BC4"], "BC4");

    } else {
        // SN
        // Try uploaded SN_DEFAULT
        let src = secondMap["SN_DEFAULT"];
        if (!src) src = secondKurtaImages["SN"];
        if (src) add(5, src, "SN_DEFAULT");
    }

    // 3. Pockets
    // previewPocket: 00, 01, 11
    if (previewPocket === '01') {
        const key = "R" + previewPocketType; // RN, RR, RS
        add(6, secondKurtaImages[key], key);
    } else if (previewPocket === '11') {
        const keyL = "L" + previewPocketType; // LN, LR, LS
        const keyR = "R" + previewPocketType; // RN, RR, RS
        add(6, secondKurtaImages[keyL], keyL);
        add(6, secondKurtaImages[keyR], keyR);
    }

    // 4. Flaps
    if (previewFlap === '1' && previewPocket !== '00') {
        if (previewPocket === '01') {
             const key = "FR" + previewFlapType;
             add(7, secondKurtaImages[key], key);
             add(9, secondKurtaImages["BPR"], "BPR");
        } else if (previewPocket === '11') {
             const keyL = "FL" + previewFlapType;
             const keyR = "FR" + previewFlapType;
             add(7, secondKurtaImages[keyL], keyL);
             add(7, secondKurtaImages[keyR], keyR);
             add(9, secondKurtaImages["BPL"], "BPL");
             add(9, secondKurtaImages["BPR"], "BPR");
        }
    }

    // 5. Epaulette
    if (previewEpaulette === 'SE') {
        add(8, secondKurtaImages["SE"], "SE");
        add(10, secondKurtaImages["BE"], "BE");
    }

    // 6. Collar & Placket
    const isShirtCollar = ["CR", "CB", "CT", "CS", "CE"].includes(previewCollar);
    
    if (isShirtCollar) {
        add(11, secondKurtaImages[previewCollar], previewCollar);
        let placketKey = previewPlacket + "3"; 
        if (!secondKurtaImages[placketKey]) {
             if (secondKurtaImages[placketKey + "1"]) placketKey += "1";
        }
        add(4, secondKurtaImages[placketKey], placketKey);
        add(12, secondKurtaImages["BKN"], "BKN");
    } else {
        // Chinese
        let placketKey = previewPlacket + "4";
        if (!secondKurtaImages[placketKey]) {
             if (secondKurtaImages[placketKey + "1"]) placketKey += "1";
        }
        add(4, secondKurtaImages[placketKey], placketKey);
        add(12, secondKurtaImages["BKC"], "BKC");
    }

    return layers.sort((a, b) => a.z - b.z);
  }, [secondMap, previewSleeve, previewVariant, previewPocket, previewPocketType, previewFlap, previewFlapType, previewEpaulette, previewCollar, previewPlacket]);

  return (
    <>
      <NavBar flag={1} />
      <div className="container" style={{ marginTop: 80, marginBottom: 60 }}>
        <h3>Test Render Upload</h3>
        <div style={{ display: 'flex', gap: 20, alignItems: 'center', marginBottom: 20 }}>
          <select value={collection} onChange={(e) => setCollection(e.target.value)}>
            <option value="kurta">kurta</option>
            <option value="Suits">Suits</option>
          </select>
          <input
            type="text"
            placeholder="Style ID"
            value={styleId}
            onChange={(e) => setStyleId(e.target.value)}
            style={{ padding: 8, flex: 1 }}
          />
        </div>

        <div style={{ display: 'flex', gap: 20, marginBottom: 20 }}>
            <label style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                <input type="radio" name="uploadMode" checked={uploadMode === 'first'} onChange={() => setUploadMode('first')} />
                1st Image Only
            </label>
            <label style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                <input type="radio" name="uploadMode" checked={uploadMode === 'second'} onChange={() => setUploadMode('second')} />
                2nd Image Only
            </label>
            <label style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                <input type="radio" name="uploadMode" checked={uploadMode === 'both'} onChange={() => setUploadMode('both')} />
                Both
            </label>
        </div>

        {(uploadMode === 'first' || uploadMode === 'both') && (
        <div style={{ padding: 16, border: '1px solid #ddd', borderRadius: 8, marginBottom: 24 }}>
          <h5>First Image</h5>
          <Uploader label="Model Body" onChange={(e) => setModelSrc(e.target.files?.[0] || null)} />
          <Uploader label="Hand (Cuff)" onChange={(e) => setHandsCuff(e.target.files?.[0] || null)} />
          <Uploader label="Hand (No Cuff)" onChange={(e) => setHandsNonCuff(e.target.files?.[0] || null)} />
          <div style={{ marginTop: 10, marginBottom: 10, fontWeight: 600 }}>Layers</div>
          {firstLayers.map((row, i) => (
            <KeyFileRow
              key={i}
              value={row}
              onChangeKey={(val) => setRowKey(i, val)}
              onChangeFile={(e) => setRowFile(i, e.target.files?.[0] || null)}
            />
          ))}
          <button className="Butt1" onClick={addRow}>Add Layer</button>
        </div>
        )}

        {(uploadMode === 'second' || uploadMode === 'both') && (
        <div style={{ padding: 16, border: '1px solid #ddd', borderRadius: 8, marginBottom: 24 }}>
          <h5>Second Image</h5>
          <Uploader label="SN_DEFAULT (No Cuff)" onChange={(e) => setSnDefault(e.target.files?.[0] || null)} />
          <div style={{ marginTop: 10, marginBottom: 6, fontWeight: 600 }}>Cuff Variants (SC_1..SC_6)</div>
          {scVariants.map((f, i) => (
            <Uploader
              key={i}
              label={`SC_${i + 1}`}
              onChange={(e) => {
                const arr = [...scVariants];
                arr[i] = e.target.files?.[0] || null;
                setScVariants(arr);
              }}
            />
          ))}
        </div>
        )}

        {/* Live Preview (layered) */}
        <div style={{ marginTop: 24, marginBottom: 24, padding: 16, border: '1px dashed #bbb', borderRadius: 8 }}>
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>Preview Controls</div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                <select value={previewSleeve} onChange={(e) => setPreviewSleeve(e.target.value)}>
                  <option value="SN">Sleeve: No Cuff (SN)</option>
                  <option value="SC">Sleeve: Cuff (SC)</option>
                </select>
                <select value={previewVariant} onChange={(e) => setPreviewVariant(e.target.value)} disabled={previewSleeve !== 'SC'}>
                  {['SC_1','SC_2','SC_3','SC_4','SC_5','SC_6'].map(v =>
                    <option key={v} value={v}>{v}</option>
                  )}
                </select>
                
                {/* Collar */}
                <select value={previewCollar} onChange={(e) => setPreviewCollar(e.target.value)}>
                    {['CR','CB','CT','CS','CE'].map(v => <option key={v} value={v}>Collar: {v}</option>)}
                </select>

                {/* Placket */}
                 <select value={previewPlacket} onChange={(e) => setPreviewPlacket(e.target.value)}>
                    {['NS','QS'].map(v => <option key={v} value={v}>Placket: {v}</option>)}
                </select>

                {/* Pocket */}
                <select value={previewPocket} onChange={(e) => setPreviewPocket(e.target.value)}>
                    <option value="00">No Pocket</option>
                    <option value="01">1 Pocket</option>
                    <option value="11">2 Pockets</option>
                </select>
                <select value={previewPocketType} onChange={(e) => setPreviewPocketType(e.target.value)} disabled={previewPocket === '00'}>
                    {['R','N','S'].map(v => <option key={v} value={v}>Pkt Type: {v}</option>)}
                </select>

                {/* Flap */}
                <select value={previewFlap} onChange={(e) => setPreviewFlap(e.target.value)} disabled={previewPocket === '00'}>
                    <option value="0">No Flap</option>
                    <option value="1">With Flap</option>
                </select>
                <select value={previewFlapType} onChange={(e) => setPreviewFlapType(e.target.value)} disabled={previewPocket === '00' || previewFlap === '0'}>
                    {['R','N','S'].map(v => <option key={v} value={v}>Flap Type: {v}</option>)}
                </select>

                {/* Epaulette */}
                <select value={previewEpaulette} onChange={(e) => setPreviewEpaulette(e.target.value)}>
                    <option value="0">No Epaulette</option>
                    <option value="SE">With Epaulette</option>
                </select>
            </div>
          </div>

          <div style={{ position: 'relative', width: 420, maxWidth: '100%', margin: '0 auto', minHeight: 600, background: '#f8f9fa', overflow: 'hidden' }}>
            {/* 1st Fold Layers */}
            {(uploadMode === 'first' || uploadMode === 'both') && (
                <>
                    {modelURL && (
                      <img src={modelURL} alt="model" style={{ position: 'relative', width: '100%', transform: 'translateX(0) scale(1.05)', transformOrigin: 'top center', zIndex: 80 }} />
                    )}
                    {firstLayerURLs.map((l, idx) => (
                      <img key={idx} src={l.url} alt={l.key} style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 90 }} />
                    ))}
                    {(previewSleeve === 'SC' ? handCuffURL : handNonCuffURL) && (
                      <img src={previewSleeve === 'SC' ? handCuffURL : handNonCuffURL} alt="hands" style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 97 }} />
                    )}
                </>
            )}

            {/* 2nd Fold Layers */}
            {(uploadMode === 'second' || uploadMode === 'both') && (
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }}>
                    {previewSecondLayers.map((layer, idx) => (
                        <img 
                            key={layer.key + idx} 
                            src={layer.src} 
                            alt={layer.key} 
                            style={{ 
                                position: 'absolute', 
                                top: 0, 
                                left: 0, 
                                width: '100%', 
                                zIndex: 100 + layer.z 
                            }} 
                        />
                    ))}
                </div>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <button className="Butt1" disabled={busy} onClick={handleSave}>
            {busy ? 'Saving...' : 'Save'}
          </button>
          <div style={{ color: msg === 'Saved' ? 'green' : 'red' }}>{msg}</div>
        </div>
      </div>
      <Foot />
    </>
  );
}
